import { render, staticRenderFns } from "./GeneralInfoCard.vue?vue&type=template&id=3cc94b8e"
import script from "./GeneralInfoCard.vue?vue&type=script&lang=js"
export * from "./GeneralInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports